import React from "react";
import graph from "./graph";
import { TaskModel } from "models";
import { useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { Badge, IconButton } from "@mui/material";
import { isEmptyObject } from "helpers/formatObject";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";

export default function TasksWidget({ title }) {
  const { userToken } = useSelector((state) => state.auth);

  const { loading, data } = useQuery(graph.list.query, {
    // pollInterval: 30000,
    variables: {
      statuses: ["TODO", "DOING"],
      belongs_to_me: 1,
    },
    context: {
      serviceName: graph.list.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const total = !isEmptyObject(data) ? data[graph.list.name]?.total : 0;

  return (
    <>
      <TaskModel
        isPopup
        isAssign={false}
        disabled={false}
        multiSelect={false}
        title={title}
        // onAssign={onAssign}
        assigning={false}
        initFilter={{ statuses: ["TODO", "DOING"], belongs_to_me: 1 }}
        preSelected={[]}
      >
        <IconButton
          disabled={loading}
          size="small"
          sx={{ color: "#fff", bgcolor: "action.hover" }}
        >
          <Badge badgeContent={total} color="default" variant="dot">
            <AssignmentRoundedIcon fontSize="small" color="inherit" />
          </Badge>
        </IconButton>
      </TaskModel>
    </>
  );
}
